import './areas.component.scss'

const areasSectionEl = document.querySelector('.areas')
if (areasSectionEl) {
  const areasMapEl = areasSectionEl.querySelector('.areas-map__svg')
  const areasLocationsLinks = areasMapEl.querySelectorAll('[data-location]')

  areasLocationsLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault()

      const currentData = link.dataset.location

      const targetEl = areasSectionEl.querySelector(`.area-cities:not(.opened)[data-location='${currentData}']`)

      if (targetEl) {
        const targetsHead = targetEl.querySelector('.area-cities__toggle')

        // link.classList.add('current')

        // areasLocationsLinks.forEach(item => {
        //   if (item !== link) {
        //     item.classList.remove('current')
        //   }
        // })

        targetsHead.click()
      }
    })
  })
}